import * as zod from 'zod'

const name = zod
  .string()
  .trim()
  .max(128)
  .regex(/^[-.,() A-Za-zÀ-ÖØ-öø-ÿ0-9]+$/u, {message: 'valid characters: alphanumeric, space, and -.,()'})

const theme = zod.object({
  primary: zod.string(),
})

export const UpdateTeamSchema = zod.object({name, theme})
export type UpdateTeamSchema = zod.infer<typeof UpdateTeamSchema>
